module.exports = __webpack_public_path__ + "static/media/phone-background-mobile.21484ddd.png";